import { TableFooter, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { CSSProperties } from "@material-ui/styles";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TablePagination from "@saleor/components/TablePagination";
import { RiderDispatchBatches_riderDispatchBatches_edges_node } from "@saleor/dispatch/types/RiderDispatchBatches";
import { renderCollection } from "@saleor/misc";
import { ListProps } from "@saleor/types";
import moment from "moment-timezone";
import * as React from "react";
import { FormattedMessage } from "react-intl";

interface DispatchHistoryListProps extends ListProps {
  batches: RiderDispatchBatches_riderDispatchBatches_edges_node[];
}

const useStyles = makeStyles(
  theme => {
    const dataDisplay: CSSProperties = {
      flex: "60%",
      overflow: "auto",
      textAlign: "left"
    };

    return {
      dataTitle: {
        display: "none !important"
      },
      dispatchTbl: {
        [theme.breakpoints.down("md")]: {
          "& thead": {
            display: "none !important"
          },
          "& thead, tbody, th, td, tr": {
            border: "none",
            display: "block"
          },
          "& tr": {
            backgroundColor: "#fff !important",
            borderBottom: "1px solid #ccc",
            paddingBottom: "30px",
            paddingTop: "30px"
          }
        },
        tableLayout: "auto",
        width: "100%"
      },
      [theme.breakpoints.down("md")]: {
        dataDisplay,
        dataGroup: {
          display: "flex"
        },
        dataTitle: {
          display: "block !important",
          flex: "40%",
          fontWeight: "bold",
          textAlign: "left"
        }
      },
      responsiveTable: {
        overflow: "auto !important"
      },
      tblCol: {
        fontSize: "1.3em",
        fontWeight: 600 as 600,
        whiteSpace: "nowrap",
        width: "auto"
      }
    };
  },
  {
    name: "DispatchHistoryList"
  }
);

const DispatchHistoryList: React.FC<DispatchHistoryListProps> = props => {
  const {
    batches,
    settings,
    disabled,
    onNextPage,
    onPreviousPage,
    pageInfo,
    onUpdateListSettings,
    onRowClick
  } = props;
  const classes = useStyles(props);

  const numberOfColumns = 4;

  return (
    <div className={classes.responsiveTable}>
      <Table className={classes.dispatchTbl}>
        <TableHead>
          <TableRow>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Trip Ticket" />
            </TableCellHeader>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Rider Name" />
            </TableCellHeader>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Time Dispatch" />
            </TableCellHeader>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Delivery Date" />
            </TableCellHeader>
            {/* <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Delivery Status" />
            </TableCellHeader> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {renderCollection(
            batches,
            (batch, index) => (
              <TableRow key={index} hover onClick={onRowClick(batch?.id)}>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Trip Ticket</div>
                    <div className={classes.dataDisplay}>
                      {batch?.batchCode}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Rider Name</div>
                    <div className={classes.dataDisplay}>
                      {batch?.rider?.firstName + " " + batch?.rider?.lastName}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Time Dispatched</div>
                    <div className={classes.dataDisplay}>
                      {moment(batch?.created).format("hh:mm A - MM/DD/YYYY")}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Delivery Date</div>
                    <div className={classes.dataDisplay}>
                      {moment(batch?.deliveryDate).format("LL")}
                    </div>
                  </div>
                </TableCell>
                {/* <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Delivery Status</div>
                    <div className={classes.dataDisplay}>
                      {moment().format("LL")}
                    </div>
                  </div>
                </TableCell> */}
              </TableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={numberOfColumns} padding="default">
                  <Typography variant="h5" align="center">
                    No Data
                  </Typography>
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={numberOfColumns}
              settings={settings}
              hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
              onNextPage={onNextPage}
              onUpdateListSettings={onUpdateListSettings}
              hasPreviousPage={
                pageInfo && !disabled ? pageInfo.hasPreviousPage : false
              }
              onPreviousPage={onPreviousPage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </div>
  );
};

export default DispatchHistoryList;
